import type { Dispatch, SetStateAction } from 'react'
import type { Language } from '~/types/api-client'
import type KeyValuePair from '~/types/key-value-pair'

export type AffiliateRouteSlug =
  | 'personal-info'
  | 'business-details'
  | 'audience-insights'
  | 'partnership-goals'
  | 'additional-info'

export const ROUTES = {
  main: '/affiliate',
  personalInfo: '/affiliate/personal-info',
  businessDetails: '/affiliate/business-details',
  audienceInsights: '/affiliate/audience-insights',
  partnershipGoals: '/affiliate/partnership-goals',
  additionalInfo: '/affiliate/additional-info',
  created: '/affiliate/created',
  error: '/affiliate/error',
  duplicated: '/affiliate/duplicated',
}

export type AffiliateOutletData = {
  mainDomainUrl: string

  countryCode: string | null
  countries: KeyValuePair[]
  communicationLanguages: Language[]

  personalInfo: Record<string, any>
  setPersonalInfo: Dispatch<SetStateAction<Record<string, any>>>
  businessDetails: Record<string, any>
  setBusinessDetails: Dispatch<SetStateAction<Record<string, any>>>
  audienceInsights: Record<string, any>
  setAudienceInsights: Dispatch<SetStateAction<Record<string, any>>>
  partnershipGoals: Record<string, any>
  setPartnershipGoals: Dispatch<SetStateAction<Record<string, any>>>
  additionalInfo: Record<string, any>
  setAdditionalInfo: Dispatch<SetStateAction<Record<string, any>>>
}
